class Item
	constructor: () ->
		@configure()
		@init()
		return @
	configure: () ->
		@regex = /0*$/g
		@regex2 = /\.$/g
		@price = $('[data-node="price"]')
		@price_val = parseFloat(@price.data('price'))
		@counts = $('[data-node="counts"]')
		@countd = $('button[data-action="cnt-decrease"]')
		@counti = $('button[data-action="cnt-increase"]')

		@input_price = $('.count-controls input[type="hidden"][name="price"]')

		@gallery = $('.gallery')
		@gallery_images = $('.gallery-images',@gallery)
		@gallery_thumbnails = $('.gallery-thumbs',@gallery)
		return
	init: () ->
		@countsListener()
		@initGallery()
		return
	initGallery: () ->
		IP = @
		ls = @gallery.data('count')
		if @gallery.length > 0
			@images = new Swiper(@gallery_images,{
				loop: true
				loopedSlides: ls
				slidesPerView: 1
				speed: 500
				effect: 'slide'
				thumbs:
					swiper:
						el: @gallery_thumbnails
						slidesPerView: 5
						spaceBetween: 5
						speed: 500
						effect: 'slide'
						breakpoints:
							768:
								slidesPerView: 4
							991:
								slidesPerView: 5
							1200:
								slidesPerView: 4
						navigation:
							nextEl: '.swiper-button-next'
							prevEl: '.swiper-button-prev'
			})
		# if @gallery_images.length > 0
		# 	@gallery_images.slick
		# 		slidesToShow: 1
		# 		slidesToScroll: 1
		# 		arrows: false
		# 		fade: true
		# 		draggable: false
		# 		swipe: false
		# 		swipeToSlide: false
		# 		touchMove: false
		# 		asNavFor: IP.gallery_thumbnails
		# if @gallery_thumbnails.length > 0
		# 	@gallery_thumbnails.slick
		# 		slidesToShow: 5
		# 		slidesToScroll: 1
		# 		asNavFor: IP.gallery_images
		# 		dots: false
		# 		draggable: false
		# 		swipe: false
		# 		swipeToSlide: false
		# 		touchMove: false
		# 		# centerMode: true
		# 		focusOnSelect: true
	countsListener: () ->
		I = @
		@counts.on 'change', (ev) ->
			ev.stopPropagation()
			ev.preventDefault()
			I.countsListenerCallback('chk')
		@countd.on 'click', (ev) ->
			ev.stopPropagation()
			ev.preventDefault()
			I.countsListenerCallback('dcr')
		@counti.on 'click', (ev) ->
			ev.stopPropagation()
			ev.preventDefault()
			I.countsListenerCallback('icr')
	countsListenerCallback: (dir) ->
		val = 0
		switch dir
			when 'dcr'
				val = @counts.val()
				val--
				if val < 1
					val = 1
				@counts.val(val)
			when 'icr'
				val = @counts.val()
				val++
				@counts.val(val)
			when 'chk'
				val = @counts.val()
				if val < 1
					val = 1
				@counts.val(val)
		price = @price_val * val
		price = @formatPrice(price)
		@price.html(price)
		@input_price.val(price)

	formatPrice: (number) ->
		decimal = 2
		decpoint = '.'
		format_string = '# руб'
		r = parseFloat(number)

		exp10 = Math.pow(10,decimal)
		r = Math.round(r*exp10) / exp10

		rr = Number(r).toFixed(decimal).toString().split('.')

		r = (if rr[1] then rr[0]+decpoint+rr[1] else rr[0])
		r = r.replace(decpoint+'00','')

		return format_string.replace('#', r)

$(document).ready () ->
	window.Item = new Item()